import React from "react";
import iconX from "../assets/images/icon-x.png";
import telegramIcon from "../assets/images/telegram-icon.png";
import iconLi from "../assets/images/icon-li.png";
import iconTg from "../assets/images/icon-tg.png";
import iconMd from "../assets/images/icon-md.png";
import iconYt from "../assets/images/icon-yt.png";
import iconIg from "../assets/images/icon-ig.png";
import iconMap from "../assets/images/icon-map.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#F6F6F2] py-6 md:py-8 lg:px-0 px-3">
      <Link
        to={`https://t.me/trlworld`}
        target="_blank"
        className="md:right-[20px] right-[10px] fixed md:bottom-[20px] bottom-[10px] z-[44] block w-fit"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
        >
          <g filter="url(#filter0_d_3386_24826)">
            <circle cx="36" cy="32" r="31.5" fill="#FF4A3F" stroke="white" />
            <path
              d="M36.0373 11.4297C47.3952 11.4409 56.5902 20.6761 56.5725 32.0565C56.5548 43.408 47.3068 52.5966 35.9248 52.5725C24.5781 52.5484 15.4008 43.2923 15.4298 31.9039C15.4587 20.5958 24.6954 11.4184 36.0373 11.4297ZM35.7577 38.5326C37.4321 39.7651 39.0391 40.9671 40.6653 42.1402C41.7163 42.897 42.4619 42.6383 42.7254 41.4058C43.8615 36.1269 44.9912 30.8465 46.0727 25.5548C46.1675 25.0904 46.0615 24.3689 45.7577 24.1037C45.4717 23.8563 44.747 23.9173 44.3018 24.0812C41.1699 25.2415 38.0604 26.4627 34.943 27.6647C31.5764 28.9615 28.2034 30.2439 24.8513 31.5761C24.4512 31.7351 24.1603 32.169 23.818 32.4743C24.1828 32.7427 24.5106 33.1139 24.9188 33.2585C26.2011 33.7165 27.5253 34.0588 28.8108 34.5071C29.4183 34.7193 29.8827 34.671 30.4403 34.3143C33.9981 32.034 37.5816 29.7923 41.1651 27.5506C41.4624 27.3642 41.8207 27.2759 42.1501 27.1409L42.4249 27.5314C42.1903 27.6599 41.9219 27.7515 41.7275 27.9251C39.3155 30.0864 36.9677 32.3249 34.4866 34.4043C33.1335 35.5388 32.1694 36.7071 32.412 38.5743C32.4586 38.9375 32.3397 39.3184 32.3285 39.6928C32.3124 40.2375 32.3236 40.7823 32.3236 41.327C32.3895 41.3849 32.457 41.4427 32.5229 41.5006C33.5851 40.5252 34.6489 39.5514 35.7593 38.5326H35.7577Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_3386_24826"
              x="0"
              y="0"
              width="72"
              height="72"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_3386_24826"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_3386_24826"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </Link>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 items-center">
          <div className="md:col-span-6 col-span-12 md:order-1 order-1">
            <div className="flex flex-row gap-x-3 items-center">
              <div className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18.875 9.2621C18.875 5.86259 15.9974 3.06553 12.5 3.06553C8.95833 3.06553 6.125 5.86259 6.125 9.2621C6.125 9.82152 6.30208 10.6391 6.78906 11.7579C7.23177 12.7907 7.89583 13.9956 8.64844 15.2005C9.93229 17.18 11.3932 19.0734 12.5 20.4504C13.5625 19.0734 15.0234 17.18 16.3073 15.2005C17.0599 13.9956 17.724 12.7907 18.1667 11.7579C18.6536 10.6391 18.875 9.82152 18.875 9.2621ZM21 9.2621C21 13.0489 15.8203 19.7188 13.5182 22.5159C12.987 23.1614 11.9688 23.1614 11.4375 22.5159C9.17969 19.7188 4 13.0489 4 9.2621C4 4.70073 7.80729 1 12.5 1C17.1927 1 21 4.70073 21 9.2621Z"
                    fill="#17271F"
                  />
                  <path
                    d="M13.9154 9.42103C13.9154 8.68949 13.2513 8.04401 12.4987 8.04401C11.7018 8.04401 11.082 8.68949 11.082 9.42103C11.082 10.1956 11.7018 10.798 12.4987 10.798C13.2513 10.798 13.9154 10.1956 13.9154 9.42103ZM8.95703 9.42103C8.95703 8.21614 9.62109 7.09731 10.7279 6.45183C11.7904 5.84939 13.1628 5.84939 14.2695 6.45183C15.332 7.09731 16.0404 8.21614 16.0404 9.42103C16.0404 10.6689 15.332 11.7878 14.2695 12.4333C13.1628 13.0357 11.7904 13.0357 10.7279 12.4333C9.62109 11.7878 8.95703 10.6689 8.95703 9.42103Z"
                    fill="#FF4A3F"
                  />
                </svg>
              </div>
              <div className="md:max-w-[400px]">
                C-12-08 Sunway Nexis Jalan PJU 5/1 Kota Damansara, 47810 PJ
                Selangor, Malaysia
              </div>
            </div>
          </div>
          <div className="md:col-span-6 col-span-12 md:order-2 order-2">
            <ul className="flex flex-row gap-x-6  md:justify-end justify-center items-center w-full md:mt-0 mt-6">
              <li>
                <Link
                  to={`https://x.com/Trl_co`}
                  target="_blank"
                  className="w-fit block"
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 24.527C3.17064 20.8413 6.25991 17.2514 9.36641 13.6394C6.25417 9.11033 3.15915 4.60519 0.0201036 0.0378149C0.230714 0.0253698 0.379099 0.00909541 0.527483 0.00909541C2.58668 0.00718077 4.64587 0.0157966 6.70507 0.00047952C7.02864 -0.00143512 7.22106 0.0971687 7.40295 0.364261C9.26302 3.09262 11.1365 5.81141 13.0071 8.53307C13.1047 8.67571 13.2091 8.81356 13.3489 9.00598C13.7653 8.52445 14.1588 8.0726 14.5493 7.61883C16.642 5.18724 18.7367 2.75852 20.8217 0.320224C21.016 0.0933395 21.2085 -0.0138804 21.5129 0.00143668C22.0375 0.0272843 22.565 0.00909541 23.2169 0.00909541C20.2081 3.50714 17.2633 6.93147 14.287 10.3922C17.5075 15.0792 20.726 19.7624 24 24.528C23.7071 24.528 23.507 24.528 23.3069 24.528C21.3118 24.528 19.3158 24.5193 17.3208 24.5366C16.98 24.5394 16.7789 24.4399 16.5846 24.1546C14.5177 21.1237 12.4356 18.1034 10.3151 15.018C10.1447 15.2104 9.9925 15.3808 9.84316 15.5531C7.38668 18.4078 4.92637 21.2597 2.48042 24.124C2.23151 24.416 1.98644 24.5663 1.59202 24.5366C1.10379 24.4992 0.61077 24.528 0.000957524 24.528L0 24.527ZM21.0237 22.9982C20.9998 22.8986 20.9998 22.8804 20.9921 22.8689C16.0983 15.8642 11.2054 8.86047 6.30778 1.85959C6.23981 1.7629 6.12493 1.63271 6.03016 1.63079C5.01923 1.61452 4.0083 1.62026 2.91887 1.62026C3.06534 1.84332 3.15532 1.98787 3.25393 2.12764C4.63247 4.10068 6.01292 6.07276 7.39242 8.04579C10.7909 12.9061 14.1875 17.7674 17.5917 22.6229C17.6989 22.7761 17.8827 22.9761 18.0369 22.9819C19.021 23.0144 20.0061 22.9982 21.0256 22.9982H21.0237Z"
                      fill="#17271F"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link
                  to={`https://www.linkedin.com/company/trlco/`}
                  target="_blank"
                  className="w-fit block"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.9992 12.0477C23.9992 15.156 24.0001 18.2653 23.9992 21.3736C23.9992 23.0009 22.9999 23.9992 21.3727 23.9992C15.1242 24.0001 8.87475 24.0001 2.62627 23.9992C0.998999 23.9992 0.000703025 22.9999 0.000703025 21.3727C-0.000234342 15.1242 -0.000234342 8.87475 0.000703025 2.62627C0.000703025 0.998999 0.999936 0.000703025 2.6272 0.000703025C8.87569 -0.000234342 15.1251 -0.000234342 21.3736 0.000703025C23.0009 0.000703025 23.9982 0.999936 23.9992 2.6272C24.001 5.76738 23.9992 8.90756 23.9992 12.0468V12.0477ZM16.7936 20.4016C17.8828 20.4016 18.9252 20.3866 19.9666 20.41C20.3303 20.4184 20.4091 20.2891 20.4072 19.9507C20.3931 17.8735 20.4091 15.7963 20.3931 13.7191C20.3903 13.3019 20.3416 12.8726 20.2347 12.4705C19.6742 10.3511 17.3889 8.94412 15.4016 9.48404C14.5411 9.71745 13.839 10.2133 13.1904 11.0073V9.5984C12.1227 9.5984 11.1094 9.6209 10.098 9.58809C9.66402 9.57403 9.58622 9.72963 9.58809 10.1233C9.60403 12.7001 9.59653 15.277 9.59653 17.8538C9.59653 18.5718 9.60965 19.2908 9.5909 20.0088C9.58247 20.32 9.69307 20.4203 9.99584 20.4062C10.4477 20.3856 10.9013 20.4016 11.3541 20.4016C11.9587 20.4016 12.5624 20.4016 13.2035 20.4016V19.8251C13.2035 17.9981 13.2016 16.1703 13.2063 14.3434C13.2063 14.0959 13.2082 13.8381 13.2701 13.601C13.4997 12.7236 14.3237 12.1705 15.2142 12.268C16.0765 12.3627 16.7758 13.1163 16.7843 14.0275C16.8021 15.9641 16.7918 17.9007 16.7927 19.8373C16.7927 20.005 16.7927 20.1719 16.7927 20.4016H16.7936ZM7.18562 9.62371C7.01783 9.61434 6.86598 9.59934 6.71506 9.59934C5.8405 9.59746 4.96593 9.61621 4.09231 9.58996C3.70893 9.57872 3.58707 9.68651 3.58894 10.083C3.60488 13.0648 3.5955 16.0475 3.60019 19.0292C3.60019 19.4632 3.46521 20.0819 3.68924 20.2816C3.94983 20.514 4.53756 20.3922 4.98374 20.3987C5.71208 20.41 6.44135 20.4016 7.18562 20.4016V9.62371ZM5.4693 3.25993C4.26291 3.22431 3.30117 4.12043 3.25993 5.3212C3.21868 6.54071 4.13355 7.51651 5.35494 7.55494C6.52384 7.5915 7.50151 6.65976 7.55213 5.45805C7.60181 4.28916 6.65976 3.29555 5.46836 3.25993H5.4693Z"
                      fill="#17271F"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link
                  to={`https://t.me/trlworld`}
                  target="_blank"
                  className="w-fit block"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0211 6.02561e-06C18.6466 0.00656774 24.0103 5.39374 24 12.0323C23.9897 18.654 18.595 24.014 11.9555 24C5.33659 23.9859 -0.0168332 18.5865 3.9776e-05 11.9433C0.0169128 5.34687 5.40502 -0.00655569 12.0211 6.02561e-06ZM11.858 15.81C12.8348 16.529 13.7721 17.2301 14.7208 17.9144C15.3338 18.3559 15.7688 18.205 15.9225 17.486C16.5852 14.4067 17.2442 11.3265 17.8751 8.23965C17.9304 7.96874 17.8685 7.54785 17.6914 7.39318C17.5245 7.24883 17.1017 7.28445 16.8421 7.38006C15.0151 8.05686 13.2013 8.76927 11.3827 9.47044C9.41891 10.2269 7.45134 10.9749 5.49595 11.752C5.26254 11.8448 5.09287 12.0979 4.89321 12.276C5.10599 12.4326 5.29722 12.6491 5.53532 12.7335C6.28335 13.0006 7.05576 13.2003 7.80567 13.4618C8.16 13.5856 8.43091 13.5574 8.75618 13.3493C10.8316 12.0192 12.9219 10.7115 15.0123 9.40388C15.1857 9.29515 15.3948 9.24359 15.5869 9.16485L15.7472 9.39263C15.6104 9.46762 15.4538 9.52106 15.3404 9.62229C13.9334 10.8831 12.5639 12.1889 11.1165 13.4018C10.3272 14.0636 9.76481 14.7451 9.90636 15.8344C9.93354 16.0462 9.86417 16.2684 9.85761 16.4868C9.84824 16.8046 9.8548 17.1223 9.8548 17.4401C9.89323 17.4739 9.9326 17.5076 9.97104 17.5413C10.5907 16.9724 11.2112 16.4043 11.8589 15.81H11.858Z"
                      fill="#17271F"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link
                  to={`https://medium.com/@TRLCo`}
                  target="_blank"
                  className="w-fit block"
                >
                  <svg
                    width="28"
                    height="16"
                    viewBox="0 0 28 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.89698 15.931C12.2581 15.931 15.7937 12.3648 15.7937 7.96565C15.7937 3.56648 12.2584 0 7.89698 0C3.53558 0 0 3.56729 0 7.96565C0 12.364 3.53585 15.931 7.89698 15.931ZM24.4566 7.96578C24.4566 12.1066 22.6888 15.4648 20.5081 15.4648C18.3274 15.4648 16.5596 12.1066 16.5596 7.96578C16.5596 3.8249 18.3271 0.46673 20.5078 0.46673C22.6885 0.46673 24.4563 3.82383 24.4563 7.96578H24.4566ZM28 7.96573C28 11.6749 27.3784 14.6837 26.6113 14.6837C25.8443 14.6837 25.2229 11.6757 25.2229 7.96573C25.2229 4.25572 25.8445 1.24777 26.6113 1.24777C27.3781 1.24777 28 4.25545 28 7.96573Z"
                      fill="#17271F"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link
                  to={`https://www.youtube.com/watch?v=5j-YLqpqb-g`}
                  target="_blank"
                  className="w-fit block"
                >
                  <svg
                    width="28"
                    height="20"
                    viewBox="0 0 28 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.5098 1.50343C26.9443 1.94066 27.2562 2.48432 27.4145 3.08C28 5.27864 28 9.86364 28 9.86364C28 9.86364 28 14.4486 27.4145 16.6473C27.2562 17.243 26.9443 17.7866 26.5098 18.2238C26.0754 18.6611 25.5337 18.9765 24.9391 19.1386C22.75 19.7273 14 19.7273 14 19.7273C14 19.7273 5.25 19.7273 3.06091 19.1386C2.46625 18.9765 1.9246 18.6611 1.49017 18.2238C1.05574 17.7866 0.743756 17.243 0.585455 16.6473C0 14.4486 0 9.86364 0 9.86364C0 9.86364 0 5.27864 0.585455 3.08C0.743756 2.48432 1.05574 1.94066 1.49017 1.50343C1.9246 1.06621 2.46625 0.750751 3.06091 0.588636C5.25 0 14 0 14 0C14 0 22.75 0 24.9391 0.588636C25.5337 0.750751 26.0754 1.06621 26.5098 1.50343ZM18.4546 9.86361L11.1364 5.7002V14.027L18.4546 9.86361Z"
                      fill="#17271F"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link
                  to={`https://instagram.com/trlco_world/`}
                  target="_blank"
                  className="w-fit block"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.0078 2.16138C15.2162 2.16138 15.5961 2.17544 16.8579 2.2317C18.0305 2.28327 18.6638 2.48019 19.0859 2.64429C19.6441 2.85995 20.0475 3.12251 20.4649 3.53978C20.8871 3.96174 21.1451 4.36026 21.3608 4.91818C21.525 5.34014 21.722 5.97777 21.7736 7.1452C21.8299 8.41108 21.844 8.79084 21.844 11.9931C21.844 15.2 21.8299 15.5797 21.7736 16.8409C21.722 18.013 21.525 18.646 21.3608 19.0679C21.1451 19.6259 20.8824 20.0291 20.4649 20.4463C20.0428 20.8683 19.6441 21.1262 19.0859 21.3418C18.6638 21.5059 18.0258 21.7028 16.8579 21.7544C15.5914 21.8107 15.2115 21.8247 12.0078 21.8247C8.7995 21.8247 8.41956 21.8107 7.1578 21.7544C5.98516 21.7028 5.35193 21.5059 4.92978 21.3418C4.37161 21.1262 3.96822 20.8636 3.55076 20.4463C3.12861 20.0244 2.87063 19.6259 2.65486 19.0679C2.49069 18.646 2.29369 18.0083 2.24209 16.8409C2.1858 15.575 2.17173 15.1953 2.17173 11.9931C2.17173 8.78616 2.1858 8.40639 2.24209 7.1452C2.29369 5.97308 2.49069 5.34014 2.65486 4.91818C2.87063 4.36026 3.1333 3.95705 3.55076 3.53978C3.97291 3.11782 4.37161 2.85995 4.92978 2.64429C5.35193 2.48019 5.98985 2.28327 7.1578 2.2317C8.41956 2.17544 8.7995 2.16138 12.0078 2.16138ZM12.0078 0C8.7479 0 8.33982 0.0140653 7.0593 0.0703267C5.78347 0.126588 4.90633 0.33288 4.14646 0.628252C3.35375 0.93769 2.683 1.34559 2.01694 2.01603C1.34619 2.68179 0.938113 3.35224 0.628536 4.1399C0.33303 4.90412 0.126645 5.77617 0.0703585 7.05143C0.0140717 8.33606 0 8.74396 0 12.0024C0 15.2609 0.0140717 15.6688 0.0703585 16.9487C0.126645 18.224 0.33303 19.1007 0.628536 19.8603C0.938113 20.6526 1.34619 21.3231 2.01694 21.9888C2.683 22.6546 3.35375 23.0672 4.14177 23.3719C4.90633 23.6673 5.77877 23.8736 7.05461 23.9298C8.33513 23.9861 8.74321 24.0002 12.0032 24.0002C15.2631 24.0002 15.6712 23.9861 16.9517 23.9298C18.2275 23.8736 19.1047 23.6673 19.8645 23.3719C20.6526 23.0672 21.3233 22.6546 21.9894 21.9888C22.6554 21.3231 23.0682 20.6526 23.3731 19.865C23.6686 19.1007 23.875 18.2287 23.9313 16.9534C23.9875 15.6735 24.0016 15.2656 24.0016 12.0071C24.0016 8.74865 23.9875 8.34075 23.9313 7.06081C23.875 5.78555 23.6686 4.90881 23.3731 4.14928C23.0776 3.35224 22.6695 2.68179 21.9987 2.01603C21.3327 1.35027 20.6619 0.93769 19.8739 0.632941C19.1094 0.337568 18.2369 0.131277 16.9611 0.0750152C15.6759 0.0140654 15.2678 0 12.0078 0ZM12.0078 5.83707C8.60246 5.83707 5.83972 8.59857 5.83972 12.0024C5.83972 15.4062 8.60246 18.1677 12.0078 18.1677C15.4132 18.1677 18.1759 15.4062 18.1759 12.0024C18.1759 8.59857 15.4132 5.83707 12.0078 5.83707ZM12.0078 16.0016C9.79856 16.0016 8.00676 14.2106 8.00676 12.0024C8.00676 9.79412 9.79856 8.00313 12.0078 8.00313C14.2171 8.00313 16.0089 9.79412 16.0089 12.0024C16.0089 14.2106 14.2171 16.0016 12.0078 16.0016ZM18.4199 7.03279C19.2126 7.03279 19.8599 6.39047 19.8599 5.59343C19.8599 4.80108 19.2126 4.15407 18.4199 4.15407C17.6272 4.15407 16.9799 4.79639 16.9799 5.59343C16.9799 6.38578 17.6225 7.03279 18.4199 7.03279Z"
                      fill="#17271F"
                    />
                  </svg>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-12 md:order-3 order-3">
            <hr className="md:my-6 my-8" />
          </div>
          <div className="md:col-span-12 col-span-12 md:order-4 order-4 xl:text-left text-center md:mt-2">
            <span className="text-[#565656] text-[14px] outfit-regular block">
              Copyright © 2024 The Real Lifestyle. All Rights Reserved.
            </span>
          </div>
          <div className="md:col-span-6 col-span-12 md:order-5 order-5 hidden">
            <ul className="flex flex-row md:gap-x-6 gap-x-2 md:justify-end justify-center w-full md:mb-0 mb-2">
              <li>
                <span className="text-[16px] text-[#17271F] outfit-medium">
                  Privacy Policy
                </span>
              </li>
              <li>
                <span className="text-[16px] text-[#17271F] outfit-medium">
                  Terms & Conditions
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
